import imageCompression from 'browser-image-compression';

import { INewFile } from '../types/interfaces/new-file';
import { checkIsImage } from './file-utils';
import { errorToastMessage } from '../components/layout/toast-root/toast';

const fileMaxSize = 10485760; // 10mb

function compressFile(file) {
  if (checkIsImage(file.type)) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const previewOptions = {
      maxWidthOrHeight: 150,
      useWebWorker: true,
    };

    return Promise.all([
      imageCompression(file, options),
      imageCompression(file, previewOptions),
    ]);
  }

  return Promise.all([Promise.resolve(file), Promise.resolve(null)]);
}

export function uploadFilesUtils(files, uploadPreview = false) {
  return Promise.all(
    [...files].map((file) => {
      function handleFile(file, previewFile) {
        if (file?.size > fileMaxSize) {
          const errorMessage = `File ${file.name} is oversized. Max file size is 10mb`;
          errorToastMessage(errorMessage);
          return Promise.resolve(undefined);
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        let readerPreview;

        if (previewFile) {
          readerPreview = new FileReader();
          readerPreview.readAsDataURL(previewFile);
        }

        return new Promise((res, rej) => {
          const fileId = Math.floor(Math.random() * 1000000);

          const result: INewFile = {
            id: fileId,
            name: file.name,
            mimeType: file.type,
            size: file.size,
            createdAt: new Date(),
            previewFileBlob: null,
            fileBlob: null,
          };

          if (readerPreview)
            readerPreview.onload = (e) => {
              result.previewFileBlob = e.target.result;

              if (result.fileBlob) {
                res(result);
              }
            };

          reader.onload = (e) => {
            result.fileBlob = e.target.result as string;

            if (result.previewFileBlob || !uploadPreview) {
              res(result);
            }
          };
        });
      }

      if (!uploadPreview) {
        return handleFile(file, null);
      }

      return compressFile(file).then(([file, previewFile]) =>
        handleFile(file, previewFile),
      );
    }),
  );
}
